import { getCheckRestrictedGroup, getTreatmentsForPatient } from 'api/apertureAPI';
import { handleError } from 'services/Error';
import { type AppThunk } from 'store';
import {
    setRestrictedGroup,
    setTreatmentSearchData,
    type TreatmentSearchParams,
} from 'store/treatments/treatmentListSlice';

export const searchTreatments =
    (searchParams: TreatmentSearchParams): AppThunk<Promise<void>> =>
    async (dispatch) => {
        try {
            const response = await getTreatmentsForPatient({
                memberId: searchParams.memberId,
                memberFirstName: searchParams.memberFirstName,
                memberLastName: searchParams.memberLastName,
                memberDob: searchParams.memberDob,
            });

            dispatch(
                setTreatmentSearchData({
                    searchParams,
                    searchResults: { treatments: response?.treatments },
                }),
            );
        } catch (err) {
            handleError('An error occurred retrieving treatments.', err as Error);
        }
    };

export const checkRestrictedGroup =
    (searchParams: TreatmentSearchParams): AppThunk<Promise<void>> =>
    async (dispatch) => {
        const restrictedGroup = await getCheckRestrictedGroup({
            groupId: searchParams.groupId!,
            memberId: searchParams.memberId,
            memberFirstName: searchParams.memberFirstName,
            memberLastName: searchParams.memberLastName,
            memberDob: searchParams.memberDob,
        });

        dispatch(setRestrictedGroup({ restrictedGroup }));
    };
